import React from "react";
import { IconButton, Snackbar } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Alert } from "@material-ui/lab";

export default function CustomSnackbar({
  snackbar,
  setSnackbar,
  snackbarMessage,
  severity,
  disableHide,
}) {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar(false);
  };

  const handleDownload = () => {
    const element = document.createElement("a");
    const file = new Blob(
      [
        Array.isArray(snackbarMessage)
          ? snackbarMessage.join("\n")
          : snackbarMessage,
      ],
      { type: "text/plain" }
    );
    element.href = URL.createObjectURL(file);
    element.download = "mesajlar.txt";
    document.body.appendChild(element);
    element.click();
  };

  return (
    <Snackbar
      open={snackbar}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
        overflowY: "auto",
      }}
      autoHideDuration={disableHide ? null : 6000}
      onClose={handleClose}
    >
      <Alert
        severity={severity}
        action={
          <>
            {Array.isArray(snackbarMessage) && (
              <IconButton
                size="small"
                aria-label="download"
                color="inherit"
                onClick={handleDownload}
              >
                <GetAppIcon fontSize="small" />
              </IconButton>
            )}
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
        style={{
          maxHeight: "600px",
          overflowY: "auto",
        }}
      >
        {Array.isArray(snackbarMessage) ? (
          <div>
            {snackbarMessage.map((msg, index) => (
              <div key={index} style={{ textAlign: "left" }}>
                {msg}
              </div>
            ))}
          </div>
        ) : (
          snackbarMessage
        )}
      </Alert>
    </Snackbar>
  );
}
